import { resolveImagePath } from "@/utils/imageResolver";

interface HeroProps {
  companyName?: string;
}

export function Hero({ companyName = "Watson Aero LLC" }: HeroProps) {
  const heroBgImage = resolveImagePath("/images/hero-bg.jpg");
  const logoImage = resolveImagePath("/images/watson-aero-logo.png");

  return (
    <section 
      id="banner"
      className="relative min-h-[600px] bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${heroBgImage})`,
        backgroundPosition: '100% 46.95%'
      }}
    >
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      {/* Content container */}
      <div id="banner-inner" className="relative z-10 flex flex-col items-center justify-center min-h-[600px] px-4 text-center">
        {/* Company name heading */}
        <div className="mb-8">
          <h1 className="text-white font-bold text-6xl lg:text-7xl xl:text-8xl mb-2" style={{ fontFamily: 'bebas_neueregular, Arial, sans-serif' }}>
            {companyName}
          </h1>
        </div>
        
        {/* Logo */}
        <div className="mb-8">
          <img 
            src={logoImage} 
            alt="Watson Aero LLC Logo" 
            className="max-w-xs md:max-w-sm lg:max-w-md mx-auto"
          />
        </div>
        
        {/* Company description */}
        <div className="max-w-4xl mx-auto">
          <p className="text-white text-lg md:text-xl leading-relaxed font-medium px-4" style={{ fontFamily: 'Lato, sans-serif' }}>
            <strong>
              Founded in 2015 and always located at the Louisville Municipal Airport (2J3) in the quiet town of Louisville, Georgia, just 50 miles south of Augusta, home of the Masters Tournament at the Augusta National, Watson Aero offers the finest craftsmanship in custom engine overhauls for your Lycoming or Continental powered aircraft. Click on the above links to learn more about Watson Aero!
            </strong>
          </p>
        </div>
      </div>
    </section>
  );
}